import ButtonSelect from "./common/ButtonSelect";

export const FlexDirectionWidget = ButtonSelect.withOptions([
	{value: 'row', label: "Row (default)"},
	{value: 'column', label: 'Column'},
	{value: 'row-reverse', label: "Row Reverse"},
	{value: 'column-reverse', label: 'Column Reverse'}
]);

export const FlexWrapWidget = ButtonSelect.withOptions([
	{value: 'nowrap', label: 'No Wrap (default)'},
	{value: 'wrap', label: 'Wrap'},
	{value: 'wrap-reverse', label: 'Wrap Reverse'}
]);

export const FlexJustifyWidget = ButtonSelect.withOptions([
	{value: 'flex-start', label: 'Start (default)'},
	{value: 'flex-end', label: 'End'},
	{value: 'center', label: 'Center'},
	{value: 'space-between', label: 'Space Between'},
	{value: 'space-around', label: 'Space Around'},
	{value: 'space-evenly', label: 'Space Evenly'}
]);

export const FlexAlignItems = ButtonSelect.withOptions([
	{value: 'strech', label: 'Stretch (default)'},
	{value: 'flex-start', label: 'Start'},
	{value: 'flex-end', label: 'End'},
	{value: 'center', label: 'Center'},
	{value: 'baseline', label: 'Baseline'}
]);

export const FlexAlignContent = ButtonSelect.withOptions([
	{value: 'stretch', label: 'Stretch (default)'},
	{value: 'flex-start', label: 'Start'},
	{value: 'flex-end', label: 'End'},
	{value: 'center', label: 'Center'},
	{value: 'space-between', label: 'Space Between'},
	{value: 'space-around', label: 'Space Around'}
]);



// WEBPACK FOOTER //
// ./src/common/form/widgets/FlexWidgets.tsx